<script setup lang="ts">
defineProps({
    classes: {
        type: String,
        default: ''
    }
});

const titleClasses = [
    'text-3.32xl',
    'lg:text-4xl xl:text-4.62xl font-bold text-center',
].join(' ');
</script>

<template>
    <h2 :class="[titleClasses, classes]">
        <slot/>
    </h2>
</template>

<style scoped>

</style>
